const AlertContext = {
  GLOBAL: 'global',
  MODAL: 'modal',
};
export default AlertContext;
